// Ausserbetriebsetzung

// state
const state = {
    propertyStreet: '',
    propertyStreetNumber: '',
    propertyZipcode: '',
    propertyCity: '',
    propertyCountryCode: '',
    plannedRealizationDate: '',
    dateEigentumerversamlung: '',
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    setPropertyStreet(state, newValue) {
        state.propertyStreet = newValue;
    },
    setPropertyStreetNumber(state, newValue) {
        state.propertyStreetNumber = newValue;
    },
    setPropertyZipAndCity(state, payload) {
        state.propertyZipcode = payload.zip;
        state.propertyCity = payload.city;
        state.propertyCountryCode = payload.countryCode;
    },
    setPlannedRealizationDate(state, newValue) {
        state.plannedRealizationDate = newValue;
    },
    setDateEigentumerversamlung(state, newValue) {
        state.dateEigentumerversamlung = newValue;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}